import AntDatePicker from "antd/es/date-picker";
import { DatePickerProps as AntDatePickerProps } from "antd/es/date-picker";
import React from "react";
import { css, useTheme } from "styled-components";
import { BOTTOM_NAVIGATOR } from "common/constants.ts";

const DatePicker = ({ className, ...props }: AntDatePickerProps) => {
  const appTheme = useTheme();
  const classNameWithDarkMode = `${className}${
    appTheme.isDarkMode ? " dark-mode" : ""
  }`;

  return (
    <AntDatePicker
      {...props}
      popupClassName={appTheme.isDarkMode ? "dark-mode" : ""}
      className={classNameWithDarkMode}
    />
  );
};

export default DatePicker;

export const datePickerStyles = css`
  .ant-picker-dropdown {
    .ant-picker-panel-container {
      background: ${(p) => p.theme.colors.layoutBgColor};
      @media (min-width: ${BOTTOM_NAVIGATOR}) {
        background: ${(p) => p.theme.colors.cardBgColor};
      }
    }
    .ant-picker-header,
    .ant-picker-content th,
    .ant-picker-cell-in-view {
      color: ${(p) => p.theme.colors.primaryText};
    }
    .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
        .ant-picker-cell-disabled
      )
      .ant-picker-cell-inner,
    .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
        .ant-picker-cell-disabled
      )
      .ant-picker-cell-inner {
      color: ${(p) => p.theme.colors.layoutBgColor} !important;
    }
    .ant-picker-cell:not(.ant-picker-cell-in-view) {
      color: ${(p) => p.theme.colors.secondaryGrey};
    }
    .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
      background: ${(p) => p.theme.colors.primaryBlue};
    }
    .ant-picker-cell-in-view.ant-picker-cell-today
      .ant-picker-cell-inner::before {
      border-color: ${(p) => p.theme.colors.primaryBlue};
    }
    .ant-picker-header-prev-btn,
    .ant-picker-header-next-btn,
    .ant-picker-header-super-prev-btn,
    .ant-picker-header-super-next-btn {
      color: ${(p) => p.theme.colors.secondaryGrey};
      &:hover {
        color: ${(p) => p.theme.colors.primaryGrey};
      }
    }
    .ant-picker-panel-container .ant-picker-presets ul li:hover {
      background: ${(p) => p.theme.colors.titleCardBgColor};
    }
  }

  ${(p) =>
    p.theme.isDarkMode &&
    `
    .ant-picker-panel-container .ant-picker-presets ul,
    .ant-picker-header {
       border-color: ${p.theme.colors.lightestGrey} !important;
    }
    `};
`;
